export default "__VITE_ASSET__BVwReexF__"